import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import PageBase from 'components/common/PageBase';
import SearchPage from 'containers/search/SearchPage';

class DENTPage extends Component {
    render() {
        const { translate} = this.props;
        return (
            <PageBase title={translate('DentForm.title')} showGoToButtons={false} >
                <SearchPage linkGoToDetails={"predictivephysicaldamage/details/"} showSingleExport={true} isIcnPlus={true} isDent={true}  />
            </PageBase>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    };
}

export default connect(mapStateToProps)(DENTPage);


// WEBPACK FOOTER //
// ./src/pages/dent/DENTPage.js